import React from "react";
import { NextPage } from "next";
import useIsMobile from "@src/hooks/useIsMobile";
import Template from "@app/Template/Template";
import PersonalDataPoliticsContent from "@features/personal-data-politics-content/personal-data-politics-content";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const PersonalDataPoliticsPage: NextPage = () => {
    const isMobile = useIsMobile();
    return (
        <Template bgColor={isMobile ? "white" : "blue"}>
            <CustomHead
                title={"Политика обработки персональных данных"}
                description={
                    "Ознакомьтесь с политикой обработки персональных данных на нашем сервисе. Важная информация для пользователей."
                }
                robots={"index,follow"}
                openGraph={{
                    title: "Политика обработки персональных данных",
                    description:
                        "Ознакомьтесь с политикой обработки персональных данных на нашем сервисе. Важная информация для пользователей.",
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        width: 1200,
                        height: 630,
                        alt: "Политика обработки персональных данных"
                    }
                }}
            />
            <PersonalDataPoliticsContent />
        </Template>
    );
};

export default PersonalDataPoliticsPage;